import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Quote } from "lucide-react";
import { Card, CardContent, CardHeader, CardFooter } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  id: 1,
  quote: "A must-visit resource for anyone serious about AI tools in 2026. The curation is simply top-tier.",
  author: "Jane D.",
  role: "Tech Entrepreneur",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559769/img/avatar_jane_d.png"
}, {
  id: 2,
  quote: "The professional reviews helped me pick the right automation tools quickly. It cuts through the marketing noise.",
  author: "Mark S.",
  role: "Product Manager",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559769/img/avatar_mark_s.png"
}, {
  id: 3,
  quote: "The depth of analysis here is unparalleled. It's my go-to for vetting new AI stacks for our enterprise clients.",
  author: "Sarah Chen",
  role: "CTO at NeuralNet",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559769/img/avatar_sarah_chen.png"
}, {
  id: 4,
  quote: "Finally, a platform that delivers raw, data-driven insights instead of just hype. Essential reading.",
  author: "David Ross",
  role: "AI Researcher",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559769/img/avatar_david_ross.png"
}, {
  id: 5,
  quote: "AIAffiliate saved us weeks of trial and error. The comparisons are spot on and technically accurate.",
  author: "Elena Rodriguez",
  role: "Founder, AutomateNow",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559769/img/avatar_elena_rodriguez.png"
}, {
  id: 6,
  quote: "Clean, precise, and reliable. Exactly what engineering leaders need to make informed tooling decisions.",
  author: "James Foster",
  role: "VP of Engineering",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559769/img/avatar_james_foster.png"
}];
export default function WhatTechLeadersSay() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="what-tech-leaders-say" ref={ref} className="relative dark bg-background text-foreground py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-5 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559769/img/grain_texture.png')] bg-repeat mix-blend-overlay z-10" />

      <div className="container mx-auto px-4 relative z-20">
        <div className="mb-16 text-center max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-6 font-sans">
            What Tech Leaders Say
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            Trusted by innovators and engineers building the future of AI.
          </p>
        </div>

        <div className={cn("columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {testimonials.map((item, i) => <div key={item.id} className="break-inside-avoid" data-index={i}>
              <Card className="bg-card/50 backdrop-blur-sm border border-border/60 hover:border-primary/30 transition-colors duration-300 rounded-xl overflow-hidden shadow-sm">
                <CardContent className="pt-8 pb-4 px-8">
                  <Quote className="w-8 h-8 text-primary/40 mb-4" />
                  <p className="text-lg md:text-xl font-serif leading-relaxed text-foreground/90 italic">
                    "{item.quote}"
                  </p>
                </CardContent>
                <CardFooter className="px-8 pb-8 pt-4 flex items-center gap-4 border-t border-border/30 mt-4">
                  <SafeHydrate><Avatar className="h-10 w-10 grayscale opacity-80 border border-border">
                    <AvatarImage src={item.avatar} alt={item.author} />
                    <AvatarFallback className="bg-muted text-muted-foreground text-xs">
                      {item.author.split(" ").map(n => n[0]).join("")}
                    </AvatarFallback>
                  </Avatar></SafeHydrate>
                  <div>
                    <h4 className="font-sans font-semibold text-sm text-foreground">
                      {item.author}
                    </h4>
                    <p className="font-sans text-xs text-muted-foreground uppercase tracking-wider">
                      {item.role}
                    </p>
                  </div>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}